export default {
    email: 'Courriel',
    phone: 'Téléphone',
    sms: 'SMS',
    messenger: 'Messenger',
    video: 'Vidéo',
};
